const generalToastedOptions = {
  position: 'top-center',
  duration: 2000,
  theme: 'bubble'
};
export const errorOptions = {
  ...generalToastedOptions,
  ...{
    type: 'error'
  }
};

export const successOptions = {
  ...generalToastedOptions,
  ...{
    type: 'success'
  }
}


export {
  default as Toasted
}
from 'vue-toasted';

export function error(message) {

  // if there is no message passed show default message
  if (!message) {
    return "Oops.. Something Went Wrong.."
  }

  // if there is a message show it with the message
  return "Oops.. " + message;

}

export function success(message) {
  // if there is no message passed show default message
  if (!message) {
    return "Done Successfully!"
  }

  // if there is a message show it with the message
  return message;

}



// WEBPACK FOOTER //
// ./src/services/vue-toasted.js